export const CONNECT = "CONNECT"
export const CONNECTED = "CONNECTED"
export const DISCONNECT = "DISCONNECT"
export const NEW_NOTIFICATION = "NEW_NOTIFICATION"
export const NEW_BOOKING_REQUEST = "NEW_BOOKING_REQUEST"
export const NEW_BOOKING = "NEW_BOOKING"


